import { AntDesign } from "@expo/vector-icons";
import {
  Banner,
  useThemeProvider,
  Text,
} from "@towersystems/roam-common-native";
import useOnline from "@towersystems/roam-common-native/lib/utilities/use-online";

export interface OfflineBannerProps {
  text?: string;
}

const DEFAULT_TEXT = "Please check your internet connection and try again.";

export const OfflineBanner = ({ text = DEFAULT_TEXT }: OfflineBannerProps) => {
  const online = useOnline();
  const { colors } = useThemeProvider();

  if (online) {
    return null;
  }

  return (
    <Banner
      title="No internet connection"
      status="warning"
      icon={
        <AntDesign
          name="exclamationcircle"
          size={20}
          color={colors.borderWarning}
        />
      }
    >
      <Text>{text}</Text>
    </Banner>
  );
};
